import React from 'react';
import { IconRight } from '@americanexpress/dls-react';

import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import { AddAccountRowViewModel } from 'src/types/view-models/atoms/add-account-row.view.model';

import colors from 'src/styles/colors.module.scss';
import styles from './addAccountList.module.scss';
import LiteralsService from 'src/services/literals/LiteralsService';
import Selectors from 'src/utils/selectors';

function AddAccountRow({ title, subtitle, onClick }: AddAccountRowViewModel): JSX.Element {
    return (
        <div className={styles.addAccountRow}>
            <div>
                <Typography component="p" variant={TypographyVariants.BODY_BOLD} className={colors.brand}>
                    {title}
                </Typography>
                <Typography component="p" variant={TypographyVariants.SUBTEXT}>
                    {subtitle}
                </Typography>
            </div>

            <button onClick={onClick}>
                <IconRight className={colors.brand} />
            </button>
        </div>
    );
}

interface AddAccountListProps {
    list: Array<{
        title: string;
        subtitle?: string;
        onClick: () => void;
    }>;
}

export default function AddAccountList({ list }: AddAccountListProps): JSX.Element {
    return (
        <div className={styles.addAccounts} data-cy={Selectors.PlanAhead.ADD_ACCOUNT_LIST}>
            <Typography variant={TypographyVariants.HEADING_XS} className={colors.textStrong}>
                {LiteralsService.getLiteral('Onboarding.addAccounts.title')}
            </Typography>

            {list.map(({ title, subtitle, onClick }, i) => (
                <AddAccountRow key={`add-account-row-${i}`} title={title} subtitle={subtitle} onClick={onClick} />
            ))}
        </div>
    );
}
